// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    findMatchingAccount,
    isNotEmpty,
    isNotNull
} from '../../services/claim-shared-helper';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../claim-fields/labeled-date-input';
import LabeledInput from '../claim-fields/labeled-input';
import Pin from '@deere/cps-it.warranty-model-factory/lib/pin';
import ResponsibleAccounts from '../claim-fields/responsible-accounts';
import moment from 'moment';

const isNotDisabled = pin => [
    isNotEmpty(pin.invoiceNumber),
    isNotNull(pin.failureDate) || isNotNull(pin.invoiceDate),
    isNotEmpty(pin.account)
].every(rule => rule);

function handleInvoiceNumberChange(invoiceNumber) {

    this.onInvoiceNumberChange(invoiceNumber);

}

function handleInvoiceDateChange(date) {

    this.onInvoicedDateChange(date);

}

function handleFailedDateChange(date) {

    this.onFailedDateChange(date);

}

function handleDealerLocationChange(dealer) {

    this.onDealerLocationChange(dealer);

}

function handleCreate() {

    this.onCreate();

}

const NonTrackedPinModalBody = props =>
    <section className='non-tracked-pin-modal-body modal-body'>
        <div className='help-text'>
            <FormattedMessage id='CREATE_NON_TRACKED_PIN_HELP_TEXT'/>
        </div>
        <div className='row'>
            <LabeledInput
                className='pin'
                isEditable={false}
                label='PIN'
                value={props.pin.pin}
            />
        </div>
        <div className='row'>
            <LabeledInput
                className='invoice-number'
                isEditable={true}
                label='INVOICE_NUMBER'
                onChange={props::handleInvoiceNumberChange}
                value={props.pin.invoiceNumber}
            />
        </div>
        <div className='row'>
            <LabeledDateInput
                className='invoice-date'
                date={props.pin.invoiceDate}
                isEditable={true}
                isValid={true}
                label='INVOICED'
                maxDate={moment()}
                onDateChange={props::handleInvoiceDateChange}
            />
            <LabeledDateInput
                className='failure-date'
                date={props.pin.failureDate}
                isEditable={true}
                isValid={true}
                label='FAILED'
                maxDate={moment()}
                onDateChange={props::handleFailedDateChange}
            />
        </div>
        <div className='row'>
            <ResponsibleAccounts
                dealers={props.dealers}
                errorMessage=''
                isEditable={true}
                isValid={true}
                onOptionBlur={() => ({})}
                onOptionChange={props::handleDealerLocationChange}
                selectedAccount={findMatchingAccount(props.pin.account, props.dealers)}
            />
        </div>
        <div className='create-button'>
            <button
                className='button-primary'
                disabled={!isNotDisabled(props.pin)}
                onClick={props::handleCreate}
            >
                <FormattedMessage id='CREATE'/>
            </button>
        </div>
    </section>;

NonTrackedPinModalBody.displayName = 'NonTrackedPinModalBody';
NonTrackedPinModalBody.propTypes = {
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    onCreate: PropTypes.func.isRequired,
    onDealerLocationChange: PropTypes.func.isRequired,
    onFailedDateChange: PropTypes.func.isRequired,
    onInvoiceNumberChange: PropTypes.func.isRequired,
    onInvoicedDateChange: PropTypes.func.isRequired,
    pin: PropTypes.instanceOf(Pin).isRequired
};

export default NonTrackedPinModalBody;



// WEBPACK FOOTER //
// ./src/claim/shared/components/non-tracked-pin-modal/non-tracked-pin-modal-body.js